<template>
    <div id="poster">
        <el-form :model="loginModel" :rules="rules" label-width="90px" ref="refForm" class="login-container">

            <h3 class="login_title">重置密码</h3>

            <el-form-item label="账号" prop="user_no">
                <el-input ref="elUserNo" v-model="loginModel.user_no" auto-complete="off" placeholder="请输入手机号码或邮箱地址">
                    <template #append>
                        <el-button :disabled="!canSend" @click="onSendCheckCode">获取验证码{{hint}}</el-button>
                    </template>
                </el-input>
            </el-form-item>

            <el-form-item label="新密码" prop="password">
                <el-input type="password" v-model="loginModel.password" auto-complete="off" ></el-input>
            </el-form-item>

            <el-form-item label="确认新密码" prop="confirm_password">
                <el-input type="password" v-model="loginModel.confirm_password" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="验证码" prop="code">
                <el-input v-model="loginModel.code" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item style="width: 100%">
                <el-button type="text" @click="onLogin">账号登录</el-button>
                <el-button type="primary" @click="onChangePassword" style="width:100px; position: absolute; right: 0px;">确定</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>
 
<script>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

import userService from '../../services/user.service'
import { isPhoneNumber, isMailAddress } from '../../utils/common'

export default {
    name: "tw-reset-password",
    setup() {
        const refForm = ref(null)
        const elUserNo = ref('')
        const router = useRouter()

        const canSend = ref(true)
        const hint = ref('')

        const loginModel = reactive({
            user_no: '',
            password: '',
            confirm_password: '',
            code: ''
        })

        const rules = {
            user_no: [
                {
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入手机号码或邮箱地址'));
                        } else {
                            const valid = isPhoneNumber(value) || isMailAddress(value)
                            if (valid) {
                                callback();
                            } else {
                                callback(new Error('请输入手机号码或邮箱地址'));
                            }
                        }
                    },
                    trigger: 'blur' 
                }
            ],
            password: [
                { validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'))
                    } else {
                        if (loginModel.confirm_password) {
                            refForm.value.validateField('confirm_password')
                        }
                        callback()
                    }
                }, trigger: 'blur' }
            ],
            confirm_password: [
                { validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请再次输入密码'));
                    } else if (value !== loginModel.password) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    }
                }, trigger: 'blur' }
            ],
            code: [
                { validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入验证码'))
                    } else {
                        callback();
                    }
                }, trigger: 'blur' }
            ]
        }

        const onLogin = function() {
            router.push({ name: 'login' })
        }

        const onChangePassword = function() {
            refForm.value.validate(valid => {
                if (valid) {
                    userService.resetPassword(loginModel.user_no, loginModel.password, loginModel.code).then(() => {
                        ElMessageBox.alert('密码重置成功', '提示信息', {
                            confirmButtonText: '确定',
                            callback: () => {
                                router.push({ name: 'login' })
                            }
                        })
                    }).catch(err => {
                        ElMessage.info({
                            showClose: true,
                            message: err.message
                        })
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }

        const onKeyDown = function(e) {
            if (e.code === 'Enter') {
                onLogin()
            }
        }

        const onSendCheckCode = function() {
            if (loginModel.user_no) {
                loginModel.type = ''
                if (isPhoneNumber(loginModel.user_no)) {
                    loginModel.type = 'phone'
                }
                if (isMailAddress(loginModel.user_no)) {
                    loginModel.type = 'mail'
                }

                if (loginModel.type) {
                    // 防止连续点击
                    canSend.value = false
                    let i = 60
                    hint.value = `(${i})`
                    var timingInterval = setInterval(() => {
                        i--;
                        hint.value = `(${i})`
                    }, 1000);
                    setTimeout(() => {
                        hint.value = ''
                        clearInterval(timingInterval)
                        canSend.value = true
                    }, 60000)

                    userService.sendCheckCode(loginModel.user_no).then(() => {
                        ElMessage.info({
                            showClose: true,
                            message: `验证码已发送到您的${loginModel.type === 'phone' ? '手机' : '邮箱' }，请注意查收`
                        })
                    }).catch(err => {
                        ElMessage.info({
                            showClose: true,
                            message: err.message
                        })
                    })
                } else {
                    ElMessage.info({
                        showClose: true,
                        message: `无效的手机号码或邮箱地址`
                    })
                }
            } else {
                ElMessage.info({
                    showClose: true,
                    message: `请录入手机号码或邮箱地址`
                })
            }
        }

        onMounted(() => {
            elUserNo.value.focus()
            document.addEventListener('keydown', onKeyDown, true)
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown, true)
        })

        return {
            refForm,
            elUserNo,
            loginModel,
            rules,
            onLogin,
            onChangePassword,
            onSendCheckCode, canSend, hint
        }
    }
}
</script>
 
<style scoped>
#poster {
    background: url("../../assets/img/eva.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
}
body {
    margin: 0px;
    padding: 0;
}

.login-container {
    border-radius: 10px;
    background-clip: padding-box;
    margin: 280px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    opacity: 0.93;
    box-sizing: content-box;
}

.login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
}

@media screen and (max-width: 451px) {
    #poster {
        background: url("../../assets/img/eva_phone.jpg") no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        background-size: cover;
        position: fixed;
    }
    .login-container {
        border-radius: 10px;
        background-clip: padding-box;
        margin: 135px auto;
        width: 250px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }
}
</style>